import React from 'react'
import {
  layout,
  makeResponsive,
  measureItems,
  SpringGrid,
} from 'react-stonecutter'
import { ItemBg, ItemSubject, ItemAttachmentLabel } from './GridTinTucStyled'
import { Divider, Dropdown, Menu, Modal } from 'antd'
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MoreOutlined,
} from '@ant-design/icons'
import { ControlNotificationFix } from '../NotificationPage/NotificationPageStyled'
import { iconMoreVert } from '../../ui_constants'
import ExclamationCircleOutlined from '@ant-design/icons/lib/icons/ExclamationCircleOutlined'
import { blue } from '../../color'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import utils from '../../utils'
import { EmptyText, WordBreak } from '../../components/Common/CellText'
import { UploadFileListWrapper } from '../../components/CommentComponent/CommentComponentStyled'
import { inject, observer } from 'mobx-react'
import { ACL_ACTION_TYPE } from '../../constants'
import GridItemSkeleton from './GridItemSkeleton'
import PopoverWatchTime from '../../components/PopoverWatchTime'

const MyFirstGrid = props => {
  let { parentWidth, tintucStore, aclStore, isLoading = false } = props
  const gutterWidth = 16
  const gutterHeight = 24
  const { aclActionsByUser } = aclStore
  const { newsList } = tintucStore

  const Grid = makeResponsive(measureItems(SpringGrid), {
    maxWidth: 1920,
  })

  parentWidth = parentWidth - gutterWidth

  const handleClickEdit = id => {
    props.onClickEdit(id)
  }

  const handleClickView = id => {
    props.onClickView(id)
  }

  const handleClickDelete = id => {
    showDeleteConfirm(id)
  }

  const { confirm } = Modal

  function showDeleteConfirm(id) {
    confirm({
      title: 'Bạn có chắc muốn xóa tin này ?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Đồng ý',
      okType: 'danger',
      cancelText: 'Không',
      onOk() {
        props.onClickDelete(id)
      },
      onCancel() {},
    })
  }

  const menuControlNotification = id => {
    return (
      <Menu>
        <Menu.Item
          onClick={() => handleClickView(id)}
          style={{ color: blue }}
          icon={<EyeOutlined />}>
          Xem chi tiết
        </Menu.Item>
        {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.edit__NEWS) && (
          <Menu.Item
            onClick={() => handleClickEdit(id)}
            style={{ color: blue }}
            icon={<EditOutlined />}>
            Sửa thông tin
          </Menu.Item>
        )}
        {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__NEWS) && (
          <Menu.Item
            onClick={() => handleClickDelete(id)}
            danger
            icon={<DeleteOutlined />}>
            Xóa
          </Menu.Item>
        )}
      </Menu>
    )
  }

  const renderItems = () => {
    if (isLoading && newsList.length === 0) {
      return Array(6)
        .fill(null)
        .map((_, idx) => (
          <div key={`skeleton-${idx}`} style={{ width: parentWidth / 2 }}>
            <GridItemSkeleton />
          </div>
        ))
    }

    return newsList.map(item => (
      <div key={item.id} style={{ width: parentWidth / 2 }}>
        <ItemBg onClick={() => props.onItemClick(item)}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              marginBottom: 12,
            }}>
            <ItemSubject style={{ flex: 1, marginRight: 12 }}>
              {item.subject}
            </ItemSubject>
            <div
              style={{ display: 'flex', alignItems: 'center', gap: 8 }}
              onClick={e => e.stopPropagation()}>
              <PopoverWatchTime
                title="Người xem"
                userList={[]}
                resourceType="news"
                typeId={item.id}
                fetchViewLogs={id => tintucStore.getNewsViewLogs(id)}
                showFullTag={false}
                verticalTag={true}
              />
              <ControlNotificationFix
                className={'control-notification'}
                style={{ flexShrink: 0 }}>
                <Dropdown
                  overlay={() => menuControlNotification(item.id)}
                  placement="bottomLeft"
                  arrow
                  trigger={['click']}>
                  <MoreOutlined style={iconMoreVert} />
                </Dropdown>
              </ControlNotificationFix>
            </div>
          </div>

          <Divider style={{ margin: '12px 0' }} />

          <div style={{ flexGrow: 1, marginBottom: 16 }}>
            {WordBreak(item.content, true)}
          </div>

          <div style={{ marginTop: 'auto' }}>
            <ItemAttachmentLabel>Tài liệu đính kèm</ItemAttachmentLabel>
            <UploadFileListWrapper style={{ gap: 8 }}>
              {item.attachments && item.attachments.length > 0 ? (
                item.attachments.map(file => (
                  <FileItem
                    key={file.file_id}
                    file_id={file.file_id}
                    file_name={file.file_name}
                    file_type={utils.getExtensionFile(file.file_name)}
                  />
                ))
              ) : (
                <EmptyText>Không có tài liệu đính kèm.</EmptyText>
              )}
            </UploadFileListWrapper>
          </div>
        </ItemBg>
      </div>
    ))
  }

  const items = renderItems()

  return (
    <div>
      <Grid
        component="ul"
        columns={2}
        columnWidth={parentWidth / 2}
        gutterWidth={gutterWidth}
        gutterHeight={gutterHeight}
        layout={layout.pinterest}>
        {items}
      </Grid>
    </div>
  )
}

export default inject('tintucStore', 'aclStore')(observer(MyFirstGrid))
